import { IServiceResult, IStoreExploreData, ITwoByTwo } from "../Models/Models";

export interface ITwoByTwoAxios {
  Get2x2(): Promise<IServiceResult<ITwoByTwo>>;
  ExploreStore(sid: number): Promise<IServiceResult<IStoreExploreData>>;
}
